import { cn } from '#/utils/cn';

interface PercentBarProps {
  /** Share of the whole, 0–100. Values are clamped into range. */
  percent: number;
  /** Accessible description, e.g. "Technology, 35% of portfolio". */
  label?: string;
  className?: string;
}

/**
 * Horizontal bar-graph fill showing a single value's share of the whole.
 * Fills from the left in dark blue with a rounded right edge.
 */
export function PercentBar({ percent, label, className }: PercentBarProps) {
  const width = Math.min(100, Math.max(0, percent));

  return (
    <div
      role="meter"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={width}
      aria-label={label}
      className={cn(
        'bg-steel-30 h-12 w-full overflow-hidden rounded-r-full',
        className,
      )}
    >
      <div
        className="bg-blue-90 h-full rounded-r-full"
        style={{ width: `${width}%` }}
      />
    </div>
  );
}
